// @unocss-include
/** 用户端设置：下载历史 */
const layout = () => import('@/layout/index.vue')
const routes = [
  {
    path: '/downloadHistory',
    name: 'DownloadHistory',
    component: layout,
    redirect: '/downloadHistory/index',
    meta: {
      title: '下载历史',
      i18Key: 'router.user.downloadHistory.index',
      roles: [1],
      category: 'setting'
    },
    sort: 45,
    children: [
      {
        path: 'index',
        name: 'DownloadHistoryIndex',
        component: () => import('@/views/DownloadHistory/Index.vue'),
        meta: {
          title: '下载历史',
          i18Key: 'router.user.downloadHistory.index',
          roles: [1]
        }
      }
    ]
  }
]
export default routes
